export enum NotificationType {
  PackingSlip = 'PackingSlip',
}

export enum NotificationChannel {
  Push = 'push',
  Email = 'email',
}

export enum NotificationCategory {
  OrderShipment = 'orderShipment',
}
